import { createContext, useContext } from 'react';

export type FormValuesObserver = (values: Record<string, any>) => void;

/**
 * Optional observer of the generic FormView values (live preview).
 * Provided by a parent (e.g. the publication wizard), null everywhere else.
 */
export const FormValuesContext = createContext<FormValuesObserver | null>(null);

export const useFormValuesObserver = () => useContext(FormValuesContext);
